<template>
  <section class="app-footer">
    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">
          Copyright © {{ date }} All rights reserved.
        </span>
        <span class="text-muted float-none float-sm-right d-block mt-1 mt-sm-0 text-center">
          KOEEBOX
          <i class="mdi mdi-heart text-danger"></i>
        </span>
      </div>
    </footer>
  </section>
</template>

<script>
export default {
  name: 'SmartOeeFooter',
  computed: {
    date() {
      return new Date().getFullYear();
    },
  },
};
</script>
